import { useMemo } from "react";
import { HOLIDAYS, type Holiday } from "@/config/holidays";

export function useHolidayTheme(): Holiday | null {
  return useMemo(() => {
    const now = new Date();
    let best: Holiday | null = null;
    for (const h of HOLIDAYS) {
      if (h.match(now) && (best === null || h.priority > best.priority)) {
        best = h;
      }
    }
    return best;
  }, []);
}
